<script setup lang="ts">
import { useAuthStore } from '~/store/authStore'

const localePath = useLocalePath()
const user = await useAuthStore().getUser()

const { data: manageStats } = useApi('/manage/stats', { key: 'manage-stats' })

definePageMeta({
  middleware: ['auth'],
})
</script>

<template>
  <UiPage
    padding
    :title="$t('Tournament Manager dashboard')"
    :description="$t('Here you manage your tournmants, locations and rankings')"
  >
    <template #top-actions>
      <UiButton
        icon="tabler-plus"
        :to="localePath('/manage/tournaments/create')"
        :text="$t('Create tournament')"
      />
    </template>
    <UiAlert
      v-if="!user?.subscription_active"
      :title="$t('IMPORTANT')"
      variant="warning"
      :description="$t('Free users can organize tournaments up to 32 players.') + ' ' + $t('Unlock more features and players by upgrading to DartsSpace Pro or DartsSpace Expert.')"
    >
      <template #action>
        <UiButton
          :href="user?.langcode === 'nl' ? 'https://about.dartsspace.com/nl/pricing' : 'https://about.dartsspace.com/pricing'"
          target="_blank"
        >
          {{ $t('View features & pricing') }}
        </UiButton>
        <UiButton
          :to="localePath('/profile/settings')"
        >
          {{ $t('Upgrade') }}
        </UiButton>
      </template>
    </UiAlert>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
      <NuxtLink
        :to="localePath('/manage/events-locations')"
      >
        <UiCard
          :title="manageStats?.events_count.toString()"
          :description="$t('Events')"
        />
      </NuxtLink>
      <NuxtLink
        :to="localePath('/manage/tournaments')"
      >
        <UiCard
          :title="manageStats?.tournaments_count.toString()"
          :description="$t('Tournaments')"
        />
      </NuxtLink>
      <NuxtLink
        :to="localePath('/manage/participants')"
      >
        <UiCard
          :title="manageStats?.participants_count.toString()"
          :description="$t('Participants')"
        />
      </NuxtLink>
      <NuxtLink
        :to="localePath('/manage/rankings')"
      >
        <UiCard
          :title="manageStats?.rankings_count.toString()"
          :description="$t('Rankings')"
        />
      </NuxtLink>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <UiButton
        stretch
        :to="localePath('/manage/tournaments')"
        icon="tabler-tournament"
        class="!h-16"
        :text="$t('Manage tournaments')"
      />
      <UiButton
        :to="localePath('/manage/events-locations')"
        icon="tabler-location"
        class="!h-16"
        :text="$t('Manage events/locations')"
      />
      <UiButton
        :to="localePath('/profile/settings')"
        icon="tabler-printer"
        class="!h-16"
        :text="$t('Go to printer settings')"
      />
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <ManageOngoingTournamentsCard />
      <ManagePlannedTournamentsCard />
      <ManageRecentTournamentsCard />
      <ManageRankingsCard />
    </div>
  </UiPage>
</template>
